var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImtoken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0H40C44.4183 0 48 3.58172 48 8V40C48 44.4183 44.4183 48 40 48H8C3.58172 48 0 44.4183 0 40V8C0 3.58172 3.58172 0 8 0Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7829 21.6315C36.2149 28.7755 30.5647 32.8016 25.0684 33.8862C23.0149 34.283 20.9648 34.2605 19.0451 33.839C14.6278 32.9005 11.0289 29.9096 10.1915 25.5823C9.19566 20.4524 12.2832 17.8437 14.8493 17.3772C17.5299 16.8681 19.9375 18.4225 20.377 20.5794C20.7513 22.624 19.5227 23.7198 18.5842 23.8907C17.8446 24.0368 16.887 23.685 16.6971 22.7881C16.5487 21.9855 16.8612 21.8653 16.6712 21.0324C16.6027 20.6356 16.4408 20.3445 16.2396 20.1389C15.708 19.5611 14.7886 19.6274 14.2479 19.8331C13.6444 20.0523 12.245 20.8773 12.5755 23.4343C12.6463 23.9986 12.8531 24.5291 13.1105 24.9854C13.2498 25.2237 13.4094 25.4508 13.6118 25.6475C13.6871 25.761 13.7815 25.8531 13.9096 25.9566C15.0549 27.0378 16.8398 27.556 18.8731 27.1693C19.489 27.0659 20.0926 26.8377 20.622 26.5995C23.1251 25.4125 24.6132 22.8285 24.4413 19.6836C24.4289 19.4847 24.4356 19.3071 24.5177 19.1183C24.557 19.034 24.5773 18.9812 24.629 18.8755C24.7211 18.7384 24.7818 18.6226 24.8942 18.4641C24.9763 18.3787 25.0898 18.2416 25.182 18.1247C26.2216 16.9591 29.3542 14.5089 33.1139 13.4804H33.1352C33.7703 13.2927 34.4795 13.1252 35.1786 13.0522C35.8991 12.9904 36.5993 12.9791 37.3321 13.0421C37.385 13.0409 37.4479 13.0612 37.4693 13.0814C37.657 13.0376 37.7952 13.1916 37.8604 13.3894C37.929 13.7749 37.9751 14.1728 38.0166 14.5684C38.2931 17.2098 38.2437 19.5533 37.7829 21.6315Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 64.5,
    y1: -27.5,
    x2: -19,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11C4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0062AD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImtoken);
export default __webpack_public_path__ + "static/media/imtoken.e575a8c868a533afad425ab04d85f01b.svg";
export { ForwardRef as ReactComponent };